import React, { createContext, useState } from "react";

// Buat Context
export const LanguageContext = createContext();

// Data bahasa disimpan di luar komponen untuk menghindari duplikasi
const languages = {
  id: {
    1: "Kelola Keamanan",
    2: "Pengelolaan data menjadi lebih mudah",
    3: "Teknologi merupakan salah satu bentuk perkembangan",
    4: "Masukan Data Diri Anda!",
    5: "Nama",
    6: "Alamat",
    7: "No.Hp",
    8: "Institusi",
    9: "Tujuan",
    10: "Janji Temu",
    11: "Buat Janji Sekarang!",
    12: "Pengunjung",
    13: "Masukan",
    14: "Anda",
    15: "Disetujui",
    16: "Cek Data Anda!",
    17: "Nama lengkap sesuai ktp",
    18: "Nomor Identitas",
    19: "Tipe Pengunjung",
    20: "Jam Kunjung Berakhir",
    21: "Departemen",
    22: "Masuk",
    23: "Cari Visitor",
    24: "Kondisi",
    25: "Status",
    26: "Pemverifikasi",
    27: "Nomor Identitas",
    28: "Satpam",
    29: "Biodata Pengunjung",
    30: "belum di approve",
    31: "belum di verifikasi",
    32: "(Sim/KTP/Passport)",
    33: "Kontraktor",
    34: "Wawancara",
    35: "Pengunjung",
    36: "Magang",
    37: "Barcode Pengunjung",
    38: "Unduh sebagai PNG",
    39: "Salin kode pengunjung anda",
    40: "Kode",
    41: "Janji Berhasil Dibuat!",
    42: "Selamat Beraktivitas!",
    43: "1 Hari",
    44: "3 Hari",
    45: "5 Hari",
    46: "1 Bulan",
    47: "3 Bulan",
    48: "6 Bulan",
    49: "Dengan Kendaraan",
    50: "Plat Nomor",
    51: "Nomor Container",
  },
  en: {
    1: "Security Management",
    2: "Managing data becomes easier",
    3: "Technology is a form of development",
    4: "Enter Your Personal Data!",
    5: "Name",
    6: "Address",
    7: "Phone",
    8: "Institution",
    9: "Purpose",
    10: "Appointment",
    11: "Make an Appointment Now!",
    12: "Visitor",
    13: "Enter",
    14: "Your",
    15: "Approve",
    16: "Find Your Data!",
    17: "Full name as on identity card",
    18: "Identity Number",
    19: "Visitor Type",
    20: "Expired Visitor Time",
    21: "Department",
    22: "Login",
    23: "Find Visitor",
    24: "Condition",
    25: "Status",
    26: "Verifikator",
    27: "Number Identity ",
    28: "Security",
    29: "Profile Visitor",
    30: "not yet approved",
    31: "not yet verified",
    32: "(Drive Lisence/Identity Number/Passport)",
    33: "Kontraktor",
    34: "Interview",
    35: "Visitor",
    36: "Intership",
    37: "Barcode Visitor",
    38: "Download as PNG",
    39: "Copy Your Visitor Code",
    40: "Code",
    41: "Appoinment Success!",
    42: "Have a good activity!",
    43: "1 Day",
    44: "3 Days",
    45: "5 Days",
    46: "1 Month",
    47: "3 Months",
    48: "6 Months",
    49: "With Vehicle",
    50: "Fleet Number",
    51: "Container Number",
  },
  chi: {
    1: "安全管理",
    2: "资料管理变更容易",
    3: "技术是一种发展形式",
    4: "请输入您的个人资料",
    5: "姓名",
    6: "地址",
    7: "电话号码",
    8: "公司名",
    9: "目的",
    10: "预约",
    11: "现在预约！",
    12: "访客",
    13: "输入",
    14: "您",
    15: "批准",
    16: "请检查您的资料",
    17: "身份证全名",
    18: "身份证号码",
    19: "访客类型",
    20: "访客过期时间",
    21: "部门",
    22: "查找访客",
    23: "情况",
    24: "状态",
    25: "审核",
    26: "身份证号码",
    27: "保安",
    28: "访客资料",
    29: "访客个人资料",
    30: "未批准",
    31: "待审核",
    32: "驾照 / 身份证 / 护照",
    33: "承包商",
    34: "面试",
    35: "参观",
    36: "实习",
    37: "访客条形码",
    38: "下载为PNG",
    39: "复制您的访客代码",
    40: "代码",
    41: "预约成功！",
    42: "祝您活动愉快！",
    43: "一天",
    44: "三天",
    45: "五天",
    46: "一个月",
    47: "三个月",
    48: "六个月",
    49: "座车",
    50: "车牌",
    51: "货柜编号",
  },
};

// Provider untuk menyediakan state bahasa ke komponen lain
export const LanguageProvider = ({ children }) => {
  // Inisialisasi state bahasa berdasarkan localStorage
  const [currentLanguage, setCurrentLanguage] = useState(
    // Jika tidak ada preferensi di localStorage, default ke "id" (bahasa Indonesia)
    localStorage.getItem("currentLanguage") || "id"
  );

  // Fungsi untuk memperbarui bahasa
  const toggleLanguage = (newLanguage) => {
    // Simpan preferensi bahasa ke localStorage
    localStorage.setItem("currentLanguage", newLanguage);
    setCurrentLanguage(newLanguage);
  };

  // Gunakan data bahasa yang sesuai berdasarkan state `currentLanguage`
  const language = languages[currentLanguage] || languages.id;

  return (
    <LanguageContext.Provider
      value={{ language, toggleLanguage, currentLanguage }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
